<template>
  <div class="p-root-categories-sidebar">
    <NuxtLink class="p-root-categories-sidebar__link" :to="link" @click="handleClick">
      <p-icon
        v-if="icon"
        class="p-root-categories-sidebar__link--icon"
        :icon="icon"
        :color="isActive ? 'fg-accent' : 'fg-primary'"
        size="xmd"
      />
      <div class="p-root-categories-sidebar__link--text" :class="{ 't-fg-accent': isActive }">
        {{ title }}
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import { usePageStore } from '@/store/page'

const props = defineProps({
  icon: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    required: true,
  },
  link: {
    type: String,
    default: '#',
  },
})

const route = useRoute()
const { page } = usePageStore()
const normalize = (p: string) => (p || '').replace(/\/+$/, '')
const isActive = computed(() => {
  const current = normalize(route.path)
  const target = normalize(props.link)
  return current === target || current.startsWith(`${target}/`)
})

const handleClick = () => {
  if (isActive.value) return

  page.pendingNavigation = true
  page.type = 'category'
}
</script>
